import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getCalibration, CalibrationResponse } from '../api/calibrationApi';
export const CALIBRATION_KEY = ['calibration'] as const;
export function calibrationQueryOptions() {
  return {
    queryKey: ['calibration', 'scorecard'] as const,
    queryFn: getCalibration,
    staleTime: 5 * 60 * 1000,
  };
}
export function useCalibration(): UseQueryResult<CalibrationResponse, Error> {
  return useQuery(calibrationQueryOptions());
}
